


































import Vue from 'vue'
import { Color, LanguageRow, UiLanguageItem, UiLanguageList } from '@/types'
//@ts-ignore
import ColorPicker from '@/components/ColorPicker'
import { QcqOperations } from '@/types/enums'
import { Work } from '@/model/master-data/Work'
import { WorkDescription } from '@/model/master-data/WorkDescription'

interface ComponentData {
  languageRows: Array<LanguageRow>
  updatedColor: string
  code: string
  codeValidationRules: Array<Function>
  languageValidationRules: Array<Function>
}

export default Vue.extend({
  name: 'WorkEditorDialog',

  components: {
    ColorPicker
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    operation: {
      type: Number
    },

    currentSelectedRowData: {
      type: Object as () => Work | undefined
    },

    loading: {
      type: Boolean
    }
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('errors.required').toString()

    return {
      languageRows: [],
      updatedColor: '#000000',
      code: '',
      codeValidationRules: [
        required
      ],
      languageValidationRules: [
        required
      ],
    }
  },

  computed: {
    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onFormSubmit (): void {
      const form: any = this.$refs['workForm']

      if (form.validate()) {
        this.$emit('save', {
          rows: this.languageRows,
          code: this.code,
          color: this.updatedColor
        })
      }
    },

    onColorChange (color: Color): void {
      if (color && color.hex) {
        this.updatedColor = color.hex
      }
    }
  },

  mounted () {
    if (this.currentSelectedRowData) {
      if (this.operation === QcqOperations.EDIT) {
        this.languageRows = this.languageRows = this.uiLanguageList.map((item: UiLanguageItem) => {
          const foundDescription: WorkDescription | undefined = this.currentSelectedRowData!.descriptionList.find((i: WorkDescription) => i.language === item.syzId)
          return {
            id: foundDescription!.id,
            code: item.syzId,
            description: foundDescription ? foundDescription.description : '' ,
            language: item.code
          }
        })
        this.code = this.currentSelectedRowData.code
        this.updatedColor = this.currentSelectedRowData.color
      } else {
        this.languageRows = this.uiLanguageList.map((item: UiLanguageItem) => {
          return {
            code: item.syzId,
            description: '',
            language: item.code
          }
        })
        this.code = ''
      }
    } else {
      this.languageRows = this.uiLanguageList.map((item: UiLanguageItem) => {
        return {
          code: item.syzId,
          description: '',
          language: item.code
        }
      })
      this.code = ''
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
